import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['ko', 'en'],
    load: 'languageOnly',
    debug: false,
    resources: messages,
    defaultNS: 'navbar',
    ns: ['navbar', 'about', 'articles', 'news'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'salted-site-language',
      convertDetectedLanguage: (language: string) => language.toLowerCase().startsWith('ko') ? 'ko' : 'en',
    },
  });

i18n.on('languageChanged', language => {
  document.documentElement.lang = language.startsWith('ko') ? 'ko' : 'en';
});
document.documentElement.lang = (i18n.resolvedLanguage || i18n.language || 'en').startsWith('ko') ? 'ko' : 'en';

export default i18n;
